import { getTagDetail } from '../../../api/tagsApi'
import TagDescriptions from '../../../components/tags/tag-descriptions/tag-descriptions'
import { ITag } from '../share-type'
import styles from './tag.module.less'
import { Space } from 'antd'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Outlet } from 'react-router-dom'

const Tag = () => {
  const params = useParams()
  const [tagId] = useState<string | undefined>(params?.id)
  const [tag, setTag] = useState<ITag>()
  useEffect(() => {
    if (tagId) {
      getTagDetail(Number(tagId)).then(res => {
        setTag(res)
      })
    }
  }, [tagId])

  return (
    <Space className={styles['tag-desc-wrapper']} orientation="vertical" size={16}>
      {tag && <TagDescriptions tag={tag} />}

      <Outlet />
    </Space>
  )
}

export default Tag
